import React from "react"

const ButtonLink = ({ link, action, className, title, isEdit = false }) => {
  const handleClick = (e) => {
    // Defensive validation
    if (!link || link.includes('undefined') || link === 'undefined#') {
      e.preventDefault();
      console.error('Invalid booking URL detected:', link);
      return;
    }
  };

  return (
    <a
      style={
        action
          ? { opacity: 1, backgroundColor: isEdit ? "#1B467F" : undefined }
          : { opacity: 0, display: "none" }
      }
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={handleClick}
    >
      {title}
    </a>
  )
}

export default ButtonLink
